export default __webpack_public_path__ + "static/media/linkedin.27beb5bf.png";